<div class="p-2 dossiers-layout">
	<div class="client-list">
		<mat-form-field class="w-100">
			<mat-label>Пребарај клиент</mat-label>
			<input matInput [(ngModel)]="clientSearchText" placeholder="име на клиент..." />
		</mat-form-field>

		<button mat-stroked-button color="primary" class="w-100 mb-2" (click)="toggleNewClientPicker()">
			<mat-icon>add</mat-icon> Нов клиент
		</button>

		@if (showNewClientPicker) {
		<div class="new-client-picker">
			<mat-form-field class="w-100">
				<mat-label>Пребарај клиент за додавање</mat-label>
				<input matInput [(ngModel)]="newClientQuery" (ngModelChange)="searchNewClient()" />
			</mat-form-field>
			@if (newClientSearching) {
			<mat-spinner diameter="20"></mat-spinner>
			}
			<div class="assign-results">
				@for (c of newClientResults; track c.id) {
				<div class="assign-result-row" (click)="pickNewClient(c)">{{ c.name }}</div>
				}
			</div>
		</div>
		}

		@if (unassignedCount > 0) {
		<div class="client-list-item unassigned" [class.selected]="selectedIsUnassigned" (click)="selectUnassigned()">
			⚠ Без клиент ({{ unassignedCount }})
		</div>
		}

		@if (clientsLoading) {
		<mat-spinner diameter="28"></mat-spinner>
		}
		@for (c of filteredClients; track c.clientId) {
		<div class="client-list-item" [class.selected]="c.clientId === selectedClientId && !selectedIsUnassigned" (click)="selectClient(c.clientId, c.clientName)">
			{{ c.clientName }}
		</div>
		}
		@if (!clientsLoading && filteredClients.length === 0) {
		<p class="text-muted small">Нема клиенти со клучни зборови.</p>
		}
	</div>

	<div class="client-detail">
		@if (!selectedClientId && !selectedIsUnassigned) {
		<p class="text-muted">Избери клиент од листата лево, додај нов преку „+ Нов клиент", или „Без клиент".</p>
		} @else {
		<div class="d-flex justify-content-between align-items-center mb-3">
			<h3 class="m-0">{{ selectedIsUnassigned ? 'Без клиент' : selectedClientName }}</h3>
			@if (!selectedIsUnassigned) {
			<button mat-icon-button color="warn" [disabled]="deletingClient" (click)="deleteClient()" title="Избриши клиент">
				<mat-icon>delete_outline</mat-icon>
			</button>
			}
		</div>

		@if (setsLoading) {
		<mat-spinner diameter="28"></mat-spinner>
		} @else {

		@if (!selectedIsUnassigned && sets.length <= 1) {
			<!-- Еден клиент, една група - картичките се директно тука, без клик за отворање. -->
			@if (expandedSetLoading) {
			<mat-spinner diameter="28"></mat-spinner>
			} @else if (expandedSet) {
			<ng-container *ngTemplateOutlet="groupBody"></ng-container>
			}
		} @else {
			<!-- Повеќе групи (или „Без клиент") - именувани, затворливи картички. -->
			<div class="set-list">
				@for (s of sets; track s.id) {
				<div class="set-card">
					<div class="set-card-header" (click)="toggleSet(s)">
						<div>
							@if (editingSetId !== s.id) {
							<strong [title]="s.name">{{ s.name }}</strong>
							} @else {
							<input class="inline-edit-input" [(ngModel)]="editingSetName" (keydown.enter)="saveSetEdit(s)" (keydown.escape)="cancelSetEdit()" (click)="$event.stopPropagation()" />
							}
							<div class="tag-chips">
								@for (t of s.tags; track t.id) {
								<span class="tag-chip" [style.background]="t.colorCode || '#999'">{{ t.value }}</span>
								}
								@if (s.tags.length === 0) {
								<span class="text-muted small">нема доделени тагови</span>
								}
							</div>
						</div>
						<div class="text-muted small d-flex align-items-center justify-content-end gap-2">
							{{ s.keywordCount }} клучни зборови · {{ s.exampleCount }} примери
							@if (!s.hasRules) {
							<span class="no-rules">· нема правила</span>
							}
							@if (selectedIsUnassigned) {
							<button mat-stroked-button (click)="startMoveToClient(s); $event.stopPropagation()">Премести кај клиент</button>
							}
							@if (editingSetId !== s.id) {
							<mat-icon class="edit-icon" (click)="startSetEdit(s); $event.stopPropagation()" title="Измени име">edit</mat-icon>
							<button mat-icon-button (click)="deleteSet(s); $event.stopPropagation()" title="Избриши група">
								<mat-icon>delete_outline</mat-icon>
							</button>
							} @else {
							<mat-icon class="edit-icon" (click)="saveSetEdit(s); $event.stopPropagation()" title="Зачувај">check</mat-icon>
							<mat-icon class="remove-icon" (click)="cancelSetEdit(); $event.stopPropagation()" title="Откажи">close</mat-icon>
							}
							<mat-icon>{{ expandedSetId === s.id ? 'expand_less' : 'expand_more' }}</mat-icon>
						</div>
					</div>

					@if (movingSetId === s.id) {
					<div class="move-client-panel">
						<mat-form-field class="w-100">
							<mat-label>Пребарај клиент</mat-label>
							<input matInput [(ngModel)]="moveClientQuery" (ngModelChange)="searchMoveClient()" placeholder="име на клиент..." />
						</mat-form-field>
						@if (moveClientSearching) {
						<mat-spinner diameter="20"></mat-spinner>
						}
						<div class="assign-results">
							@for (c of moveClientResults; track c.id) {
							<div class="assign-result-row" (click)="moveSetToClient(s, c)">{{ c.name }}</div>
							}
						</div>
					</div>
					}

					@if (expandedSetId === s.id) {
					<div class="set-card-body">
						@if (expandedSetLoading) {
						<mat-spinner diameter="28"></mat-spinner>
						} @else if (expandedSet) {
						<ng-container *ngTemplateOutlet="groupBody"></ng-container>
						}
					</div>
					}
				</div>
				}
				@if (sets.length === 0) {
				<p class="text-muted">Нема групи. Создај нова погоре.</p>
				}
			</div>

			@if (selectedIsUnassigned) {
			<div class="d-flex gap-2 mb-3 mt-3 align-items-end">
				<mat-form-field class="flex-grow-1">
					<mat-label>Нова група</mat-label>
					<input matInput [(ngModel)]="newSetName" (keydown.enter)="createSet()" placeholder="пр. Главен, Конкуренција..." />
				</mat-form-field>
				<button mat-flat-button color="primary" (click)="createSet()">Нова група</button>
			</div>
			}
		}

		@if (!selectedIsUnassigned) {
		<div class="mt-3">
			@if (!addingGroup) {
			<button mat-button class="link-btn" (click)="startAddGroup()">+ Додај уштe една група</button>
			} @else {
			<div class="d-flex gap-2 align-items-end">
				<mat-form-field class="flex-grow-1">
					<mat-label>Име на групата</mat-label>
					<input matInput [(ngModel)]="newGroupName" (keydown.enter)="confirmAddGroup()" placeholder="пр. Конкуренција" />
				</mat-form-field>
				<button mat-flat-button color="primary" (click)="confirmAddGroup()">Додај</button>
				<button mat-button (click)="cancelAddGroup()">Откажи</button>
			</div>
			}
		</div>

		<!-- Исклучени профили на клиентот - сосема на дното, затворено по стандард. -->
		<div class="section-card mt-3">
			<div class="section-header" (click)="toggleSection('excluded')">
				<span>Исклучени профили на клиентот ({{ excludedProfiles.length }})</span>
				<mat-icon>{{ openSections.excluded ? 'expand_less' : 'expand_more' }}</mat-icon>
			</div>
			@if (openSections.excluded) {
			<div class="section-body">
				<p class="text-muted small">Објавите од овие профили/групи се отфрлаат автоматски, без AI, за сите групи на клиентот.</p>
				<div class="excluded-list">
					@for (p of excludedProfiles; track p.id) {
					<div class="excluded-row">
						@if (editingExcludedId !== p.id) {
						<span class="excluded-label" [title]="p.label || p.slug || p.externalId || p.sourceLink">{{ p.label || p.slug || p.externalId || p.sourceLink }}</span>
						<span class="text-muted small">({{ p.profileType === 'GROUP' ? 'група' : 'профил' }})</span>
						<mat-icon class="edit-icon" (click)="startExcludedEdit(p)" title="Измени име">edit</mat-icon>
						<mat-icon class="remove-icon" (click)="deleteExcludedProfile(p.id, p.label || p.slug || p.sourceLink || '')">close</mat-icon>
						} @else {
						<input class="inline-edit-input flex-grow-1" [(ngModel)]="editingExcludedLabel" placeholder="Име" (keydown.enter)="saveExcludedEdit()" (keydown.escape)="cancelExcludedEdit()" />
						<mat-icon class="edit-icon" (click)="saveExcludedEdit()" title="Зачувај">check</mat-icon>
						<mat-icon class="remove-icon" (click)="cancelExcludedEdit()" title="Откажи">close</mat-icon>
						}
					</div>
					}
					@if (excludedProfiles.length === 0) {
					<p class="text-muted">Нема исклучени профили за овој клиент.</p>
					}
				</div>
				<div class="d-flex gap-2 mt-2">
					<mat-form-field class="flex-grow-1">
						<mat-label>Facebook линк</mat-label>
						<input matInput [(ngModel)]="newExcludedLink" placeholder="https://www.facebook.com/..." />
					</mat-form-field>
					<mat-form-field>
						<mat-label>Име (опционално)</mat-label>
						<input matInput [(ngModel)]="newExcludedLabel" />
					</mat-form-field>
					<button mat-flat-button color="primary" (click)="addExcludedProfile()">Исклучи</button>
				</div>
				@if (savedFlash.excluded) {
				<div class="saved-flash">Зачувано</div>
				}
			</div>
			}
		</div>
		}

		}
		}
	</div>
</div>

<ng-template #groupBody>
	@if (!expandedSet?.clientId) {
	<div class="assign-client-banner">
		⚠ Избери клиент за оваа група
		<div class="d-flex gap-2 mt-1">
			<mat-form-field class="flex-grow-1">
				<mat-label>Пребарај клиент</mat-label>
				<input matInput [(ngModel)]="assignClientQuery" (ngModelChange)="searchAssignClient()" />
			</mat-form-field>
		</div>
		@if (assignClientResults.length > 0) {
		<div class="assign-results">
			@for (c of assignClientResults; track c.id) {
			<div class="assign-result-row" (click)="assignClientToExpandedSet(c)">{{ c.name }}</div>
			}
		</div>
		}
	</div>
	}

	<!-- Клучни зборови -->
	<div class="section-card">
		<div class="section-header" (click)="toggleSection('keywords')">
			<span>Клучни зборови ({{ expandedSet!.keywords.length }})</span>
			<mat-icon>{{ openSections.keywords ? 'expand_less' : 'expand_more' }}</mat-icon>
		</div>
		@if (openSections.keywords) {
		<div class="section-body">
			<div class="d-flex flex-wrap gap-2 mb-2">
				@for (k of expandedSet!.keywords; track k.id) {
				<span
					class="keyword-chip"
					[class]="healthClass(k.id)"
					[title]="keywordHealth[k.id] ? ('7 дена: ' + keywordHealth[k.id].collected7d + ' собрани, ' + keywordHealth[k.id].new7d + ' нови, ' + keywordHealth[k.id].accepted7d + ' прифатени') : ''"
				>
					@if (editingKeywordId !== k.id) {
					{{ k.text }}
					} @else {
					<input class="inline-edit-input" [(ngModel)]="editingKeywordText" (keydown.enter)="saveKeywordEdit()" (keydown.escape)="cancelKeywordEdit()" (click)="$event.stopPropagation()" />
					}
					<mat-icon class="tag-plus-icon" [class.has-extra]="(k.tags?.length ?? 0) > 0" (click)="openKeywordTagPicker(k)" title="+ друг таг">local_offer</mat-icon>
					@if (editingKeywordId !== k.id) {
					<mat-icon class="edit-icon" (click)="startKeywordEdit(k)" title="Измени">edit</mat-icon>
					<mat-icon class="remove-icon" (click)="deleteKeyword(k.id, k.text)">close</mat-icon>
					} @else {
					<mat-icon class="edit-icon" (click)="saveKeywordEdit()" title="Зачувај">check</mat-icon>
					<mat-icon class="remove-icon" (click)="cancelKeywordEdit()" title="Откажи">close</mat-icon>
					}
				</span>
				}
				@if (expandedSet!.keywords.length === 0) {
				<span class="text-muted">Нема клучни зборови за оваа група.</span>
				}
			</div>

			@if (keywordTagPickerKeyword) {
			<div class="keyword-tag-picker">
				<div class="d-flex justify-content-between align-items-center mb-1">
					<strong class="small">+ друг таг за „{{ keywordTagPickerKeyword.text }}"</strong>
					<mat-icon class="remove-icon" (click)="closeKeywordTagPicker()">close</mat-icon>
				</div>
				<div class="category-list">
					@for (category of categories; track category.id) {
					<div class="category-item">
						<div class="category-header" (click)="toggleCategory(category)">{{ category.value }}</div>
						@if (category.opened) {
						<div class="category-tags">
							@for (tag of keywordPickerTags(category); track tag.id) {
							<mat-checkbox [checked]="isKeywordTagChecked(tag.id)" (change)="onKeywordTagCheck($event, tag.id)">{{ tag.value }}</mat-checkbox>
							}
							@if (keywordPickerTags(category).length === 0) {
							<span class="text-muted small">Нема тагови во оваа категорија (сите се веќе доделени на групата).</span>
							}
						</div>
						}
					</div>
					}
				</div>
				<button mat-flat-button color="primary" class="mt-2" (click)="saveKeywordTags()">Зачувај</button>
			</div>
			}

			<mat-form-field class="w-100">
				<mat-label>Нов клучен збор (Enter додава; залепи листа за сите одеднаш)</mat-label>
				<input matInput [(ngModel)]="newKeywordText" (keydown.enter)="addKeywordFromInput()" (paste)="onKeywordPaste($event)" />
			</mat-form-field>
			@if (savedFlash.keywords) {
			<div class="saved-flash">Зачувано</div>
			}
		</div>
		}
	</div>

	<!-- Тагови -->
	<div class="section-card">
		<div class="section-header" (click)="toggleTagsSection()">
			<span>Тагови што се доделуваат ({{ expandedSet!.tags.length }})</span>
			<mat-icon>{{ openSections.tags ? 'expand_less' : 'expand_more' }}</mat-icon>
		</div>
		@if (openSections.tags) {
		<div class="section-body">
			<div class="category-list">
				@for (category of categories; track category.id) {
				<div class="category-item">
					<div class="category-header" (click)="toggleCategory(category)">{{ category.value }}</div>
					@if (category.opened) {
					<div class="category-tags">
						@for (tag of category.tags; track tag.id) {
						<mat-checkbox [checked]="isTagChecked(tag.id)" (change)="onTagCheck($event, tag.id)">{{ tag.value }}</mat-checkbox>
						}
						@if (!category.tags || category.tags.length === 0) {
						<span class="text-muted small">Нема тагови во оваа категорија.</span>
						}
					</div>
					}
				</div>
				}
			</div>
			<button mat-flat-button color="primary" class="mt-2" (click)="saveTags()">Зачувај тагови</button>
			@if (savedFlash.tags) {
			<div class="saved-flash">Зачувано</div>
			}
		</div>
		}
	</div>

	<!-- Правила -->
	<div class="section-card">
		<div class="section-header" (click)="toggleSection('rules')">
			<span>Правила</span>
			<mat-icon>{{ openSections.rules ? 'expand_less' : 'expand_more' }}</mat-icon>
		</div>
		@if (openSections.rules) {
		<div class="section-body">
			<mat-form-field class="w-100">
				<textarea matInput rows="6" [(ngModel)]="rulesText" placeholder="Важи кога... НЕ важи кога..."></textarea>
			</mat-form-field>
			<button mat-flat-button color="primary" [disabled]="savingRules" (click)="saveRules()">Зачувај правила</button>
			@if (savedFlash.rules) {
			<div class="saved-flash">Зачувано</div>
			}
		</div>
		}
	</div>

	<!-- Примери -->
	<div class="section-card">
		<div class="section-header" (click)="toggleSection('examples')">
			<span>Примери ({{ expandedSet!.examples.length }})</span>
			<mat-icon>{{ openSections.examples ? 'expand_less' : 'expand_more' }}</mat-icon>
		</div>
		@if (openSections.examples) {
		<div class="section-body">
			<div class="examples-list">
				@for (e of expandedSet!.examples; track e.id) {
				<div class="example-row">
					<span class="example-decision" [class.yes]="e.decision" [class.no]="!e.decision">{{ e.decision ? 'ДА' : 'НЕ' }}</span>
					<span class="example-snippet">{{ e.snippet }}</span>
					@if (e.reason) {
					<span class="text-muted">({{ e.reason }})</span>
					}
					<mat-icon class="remove-icon" (click)="deleteExample(e.id)">close</mat-icon>
				</div>
				}
				@if (expandedSet!.examples.length === 0) {
				<p class="text-muted">Нема примери уште - ќе се полнат сами од корекциите.</p>
				}
			</div>
			<div class="d-flex flex-wrap gap-2 mt-2 align-items-end">
				<mat-form-field class="flex-grow-1">
					<mat-label>Текст на пример</mat-label>
					<input matInput [(ngModel)]="newExampleSnippet" />
				</mat-form-field>
				<mat-form-field>
					<mat-label>Одлука</mat-label>
					<select matNativeControl [(ngModel)]="newExampleDecision">
						<option [ngValue]="true">ДА</option>
						<option [ngValue]="false">НЕ</option>
					</select>
				</mat-form-field>
				<mat-form-field class="flex-grow-1">
					<mat-label>Причина (опционално)</mat-label>
					<input matInput [(ngModel)]="newExampleReason" />
				</mat-form-field>
				<button mat-flat-button color="primary" (click)="addExample()">Додај пример</button>
			</div>
			@if (savedFlash.examples) {
			<div class="saved-flash">Зачувано</div>
			}
		</div>
		}
	</div>
</ng-template>
